import Spinner from '@components/_elements/Spinner/Spinner';
import SimplePointDataTableWithTitle from '@components/_shared/MultiColPointDataTableWithTitle';
import useGetInternalWidgetConfig from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import { WidgetTypeMultiSectionPointList } from '@src/types/Widget';

interface Props {
  selectedBessId: string;
}

function PowinBessDetails(props: Props) {
  const { selectedBessId } = props;

  const { data: widgetConfig, isLoading } =
    useGetInternalWidgetConfig<WidgetTypeMultiSectionPointList>(
      'powinBessDetailsModal',
      {
        sourceDeviceId: selectedBessId,
      },
      {
        enabled: !!selectedBessId,
        queryKeys: [`powinBessDetails-${selectedBessId}`],
      },
    );

  return isLoading ? (
    <Spinner type='content-small' />
  ) : (
    widgetConfig?.sections?.map((sectionData, i) => (
      <SimplePointDataTableWithTitle
        key={`powinbess-details-${Math.random()}`}
        sectionIndex={i}
        data={sectionData}
      />
    ))
  );
}

export default PowinBessDetails;
